<div class="aw-dialog">
  <h1 class="aw-dialog-header">
    Manage Your Admin/Member
    <awair-info-button
      style="margin-left: auto"
      [isActive]="isInfoPopup"
      (selected)="openInfoPopup($event)">
    </awair-info-button>
    <div *ngIf="isInfoPopup" class="info-popup">
      <h3 class="info-popup__header">Admins</h3>
      <p class="info-popup__body" style="margin-bottom: 32px;">
        Those with Admin rights will have full access to their organization’s dashboard features. They will be able to see all devices, create groups, add/remove members, access the weekly report, export data, set notifications, and leave air notes.
      </p>
      <h3 class="info-popup__header">Members</h3>
      <p class="info-popup__body">
        Those with Member rights will be able to view the specific groups they are assigned to, and  will be able to leave air notes—other dashboard features will only be available if they are granted Admin rights, Members can be added to specific groups via the group management tool.
      </p>
    </div>
  </h1>
  <h2 class="aw-dialog-sub-header">Allow your team Admin/Member to view your org.</h2>

  <!-- Awair Tab -->
  <awair-tab-group class="__tab-group"
                   [selectedTabIndex]="selectedTabIndex"
                   (selectTabIndex)="tabSelected($event)">
    <!-- Admins -->
    <awair-tab [title]="'Admins'">
      <ul class="aw-lg-list" *ngIf="(orgOwner$ | async) != null" awairScrollPrevent>
        <!-- Active Admins -->
        <li class="aw-lg-list-item" *ngFor="let activeOrgAdmin of activeOrgAdminWithStatusList | objArraySort:'email'; let i = index">
          <div class="float-left flex-col" style="height: 40px; max-width: 80%;">
            <div class="aw-lg-list-item__main">
              {{activeOrgAdmin.email}}
            </div>
            <div class="aw-lg-list-item__sub">
              {{activeOrgAdmin.firstName}} {{activeOrgAdmin.lastName}}
            </div>
          </div>
          <div class="float-right flex-row" style="height: 40px">
            <ng-container [ngSwitch]="activeOrgAdmin.removed">
              <div *ngSwitchCase="true" class="aw-lg-list-item__tail--red">Remove</div>
              <div *ngSwitchDefault class="aw-lg-list-item__tail">Admin</div>
            </ng-container>
            <!-- More -->
            <awair-dropdown-wrapper>
              <awair-more-button dropdown-btn></awair-more-button>
              <awair-dropdown-ul dropdown>
                <ng-container [ngSwitch]="activeOrgAdmin.removed">
                  <li *ngSwitchCase="true" class="more-list-item" (click)="undoRemoveFromOrg(activeOrgAdmin)">Undo</li>
                  <li *ngSwitchDefault class="more-list-item--red" (click)="removeFromOrg(activeOrgAdmin)">Remove</li>
                </ng-container>
              </awair-dropdown-ul>
            </awair-dropdown-wrapper>
            <!-- /.More -->
          </div>
        </li>
        <!-- /.Active Admins -->

        <!-- Pending Admins -->
        <li class="aw-lg-list-item--blur" *ngFor="let pendingOrgAdmin of pendingOrgAdminWithStatusList | objArraySort:'email'; let i = index">
          <div class="float-left flex-col" style="height: 40px; max-width: 80%;">
            <div class="aw-lg-list-item__main--blur">
              {{pendingOrgAdmin.email}}
            </div>
            <div class="aw-lg-list-item__sub">
              Pending
            </div>
          </div>

          <div class="float-right flex-row" style="height: 40px">
            <ng-container [ngSwitch]="pendingOrgAdmin.removed">
              <div *ngSwitchCase="true" class="aw-lg-list-item__tail--red">Remove</div>
              <div *ngSwitchDefault class="aw-lg-list-item__tail">Admin</div>
            </ng-container>
            <!-- More -->
            <awair-dropdown-wrapper>
              <awair-more-button dropdown-btn></awair-more-button>
              <awair-dropdown-ul dropdown [verticalAlignment]="(i === pendingOrgAdminWithStatusList.length - 1) &&
                (activeOrgAdminWithStatusList.length + pendingOrgAdminWithStatusList.length > 1) ?
                VerticalAlignment.Top : VerticalAlignment.Bottom">
                <ng-container [ngSwitch]="pendingOrgAdmin.removed">
                  <li class="more-list-item--blue" (click)="onReinviteAdmin(pendingOrgAdmin)">Resend</li>
                  <li *ngSwitchCase="true" class="more-list-item" (click)="undoRemovePendingAdminFromOrg(pendingOrgAdmin)">Undo</li>
                  <li *ngSwitchDefault class="more-list-item--red" (click)="removePendingAdminFromOrg(pendingOrgAdmin)">Remove</li>
                </ng-container>
              </awair-dropdown-ul>
            </awair-dropdown-wrapper>
            <!-- /.More -->
          </div>

        </li>
        <!-- /.Pending Admins -->
      </ul>
    </awair-tab>
    <!-- /.Admins -->

    <!-- Members -->
    <awair-tab [title]="'Members'">
      <ul class="aw-lg-list" *ngIf="(orgOwner$ | async) != null" awairScrollPrevent>
        <!-- Active Members -->
        <li class="aw-lg-list-item" *ngFor="let activeOrgMember of activeOrgMemberWithStatusList | objArraySort:'email'; let i = index">
          <div class="float-left flex-col" style="height: 40px">
            <div class="aw-lg-list-item__main">
              {{activeOrgMember.email}}
            </div>
            <div class="aw-lg-list-item__sub">
              {{activeOrgMember.firstName}} {{activeOrgMember.lastName}}
            </div>
          </div>
          <div class="float-right flex-row" style="height: 40px; max-width: 80%">
            <ng-container *ngIf="activeOrgMember.removed">
              <div class="aw-lg-list-item__tail--red">Remove</div>
            </ng-container>
            <ng-container *ngIf="activeOrgMember.unassigned">
              <div class="aw-lg-list-item__tail--blue">Unassigned</div>
            </ng-container>
            <ng-container *ngIf="!activeOrgMember.removed && !activeOrgMember.unassigned" [ngSwitch]="activeOrgMember.groups.length">
              <div class="aw-lg-list-item__tail" *ngSwitchCase="0">Unassigned</div>
              <div class="aw-lg-list-item__tail" *ngSwitchCase="1">{{activeOrgMember.groups.length}} Group</div>
              <div class="aw-lg-list-item__tail" *ngSwitchDefault>{{activeOrgMember.groups.length}} Groups</div>
            </ng-container>

            <!-- More -->
            <awair-dropdown-wrapper>
              <awair-more-button dropdown-btn></awair-more-button>
              <awair-dropdown-ul dropdown>
                <li class="more-list-item--red"
                    *ngIf="!activeOrgMember.removed && !activeOrgMember.unassigned && activeOrgMember.groups.length > 0"
                    (click)="removeMemberFromAllGroup(activeOrgMember)">Delete Member From All Groups
                </li>
                <li class="more-list-item--red"
                    *ngIf="!activeOrgMember.removed && !activeOrgMember.unassigned"
                    (click)="removeFromOrg(activeOrgMember)">Remove
                </li>
                <li class="more-list-item" *ngIf="activeOrgMember.removed" (click)="undoRemoveFromOrg(activeOrgMember)">Undo</li>
                <li class="more-list-item" *ngIf="activeOrgMember.unassigned" (click)="undoRemoveMemberFromAllGroup(activeOrgMember)">Undo</li>
              </awair-dropdown-ul>
            </awair-dropdown-wrapper>
            <!-- /.More -->

          </div>
        </li>
        <!-- /.Active Members -->

        <!-- Pending Members -->
        <li class="aw-lg-list-item--blur" *ngFor="let pendingOrgMember of pendingOrgMemberWithStatusList | objArraySort:'email'; let i = index">
          <div class="float-left flex-col" style="height: 40px; max-width: 80%;">
            <div class="aw-lg-list-item__main--blur">
              {{pendingOrgMember.email}}
            </div>
            <div class="aw-lg-list-item__sub">
              Pending
            </div>
          </div>

          <div class="float-right flex-row" style="height: 40px">
            <ng-container [ngSwitch]="pendingOrgMember.removed">
              <div *ngSwitchCase="true" class="aw-lg-list-item__tail--red">Remove</div>
              <div *ngSwitchDefault class="aw-lg-list-item__tail">Member</div>
            </ng-container>
            <!-- More -->
            <awair-dropdown-wrapper>
              <awair-more-button dropdown-btn></awair-more-button>
              <awair-dropdown-ul dropdown [verticalAlignment]="(i === pendingOrgMemberWithStatusList.length - 1) &&
                (activeOrgMemberWithStatusList.length + pendingOrgMemberWithStatusList.length > 1) ?
                VerticalAlignment.Top : VerticalAlignment.Bottom">
                <ng-container [ngSwitch]="pendingOrgMember.removed">
                  <li class="more-list-item--blue" (click)="onReinviteMember(pendingOrgMember)">Resend</li>
                  <li *ngSwitchCase="true" class="more-list-item" (click)="undoRemovePendingMemberFromOrg(pendingOrgMember)">Undo</li>
                  <li *ngSwitchDefault class="more-list-item--red" (click)="removePendingMemberFromOrg(pendingOrgMember)">Remove</li>
                </ng-container>
              </awair-dropdown-ul>
            </awair-dropdown-wrapper>
            <!-- /.More -->
          </div>
        </li>
        <!-- /.Pending Members -->
      </ul>
    </awair-tab>
    <!-- /.Members -->

    <!-- Invitees -->
    <awair-tab [title]="'Invite Admins'">
      <ul class="aw-lg-list" *ngIf="(orgOwner$ | async) != null" awairScrollPrevent>
        <li class="aw-lg-list-item" *ngFor="let invitee of inviteeList; let i = index">
          <div class="float-left flex-col" style="height: 40px; max-width: 80%">
            <div class="aw-lg-list-item__main">{{invitee}}</div>
            <div class="aw-lg-list-item__sub">Invite</div>
          </div>
          <div class="float-right flex-row" style="height: 40px">
            <img class="aw-lg-list-item__tail-ico aw-cursor-pointer" src="assets/images/invite/ic_cancel.svg" (click)="removeInvitee(invitee)">
          </div>
        </li>
      </ul>
    </awair-tab>
    <!-- /.Invitees -->

  </awair-tab-group>
  <!-- /.Awair Tab -->

  <!-- Invite members -->
  <ng-container *ngIf="selectedTabIndex !== 1">
    <h3 class="aw-section-header" style="margin-bottom: 8px;">Invite Admins</h3>
    <awair-invite-input style="display: block; margin-bottom: 4px;"
      [inviteeList]="inviteeList"
      [orgUserList]="orgUserList$ | async"
      [pendingAdminList]="pendingOrgAdminList$ | async"
      [pendingMemberList]="pendingOrgMemberList$ | async"
      (add)="addInvitee($event)">
    </awair-invite-input>
  </ng-container>
  <!-- /.Invite members -->

  <!-- Counters -->
  <div class="counter-container" style="margin-bottom: 32px;">
    <p class="counter" *ngIf="unassignedCtr > 0">Unassigning: {{unassignedCtr}}</p>
    <p class="counter" *ngIf="removeCtr > 0">Removing: {{removeCtr}}</p>
    <p class="counter" *ngIf="addCtr > 0">Inviting: {{addCtr}}</p>
  </div>
  <!-- /.Counters -->

  <!-- Buttons -->
  <div class="btn-set">
    <button class="aw-btn aw-btn-gray" style="margin-right: 8px;" (click)="onClose()">Close</button>
    <button class="aw-btn aw-btn-blue"
      (click)="onSave()"
      [disabled]="(addCtr === 0 && removeCtr === 0 && unassignedCtr === 0) || isLoading">Save
    </button>
  </div>
  <!-- /.Buttons -->

</div>
